<div class="container-fluid">
  <div class="row">
      <div class="pnl-header col-12">
          <app-header></app-header>
      </div>
      <div class="pnl-content col-12">
        <app-cookies-policy-content></app-cookies-policy-content>
      </div>
      <div class="pnl-footer col-12">
         <app-footer></app-footer>
      </div>
  </div>
</div>